import styled from 'styled-components';
export default styled.div `
	color: var(--theme-article-text-color);
	flex: 2;
	padding: 12px 18px;
	position: relative;
`;
